export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.6.3-0923.51",
  commitId: "ea88315f5cf3a41e1701fa8e487078a0f854c2c7",
  commitTime: "2026-06-03T09:23:51.000Z",
});
